import axios from "axios";
import { create } from "zustand";
import { RepoList } from "../types/repositoryes";
import { persist, createJSONStorage } from "zustand/middleware";

interface AuthState {
  repo: RepoList[] | null;
  getRepositories: () => Promise<RepoList[] | null>;
  toggleFavorite: (owner: string, repository: string, isFavorite: boolean) => Promise<boolean>;
  clearStore: () => void;
}

export const useRepoStore = create(
  persist<AuthState>(
    (set) => ({
      repo: null,
      getRepositories: async () => {
        try {
          const response = await axios.get("/repo/repositories", {
            withCredentials: true,
          });
          const repositories = (response.data as RepoList[]).sort((a, b) => {
            if (!!a.isFavorite === !!b.isFavorite) return 0;
            return a.isFavorite ? -1 : 1;
          });
          set({ repo: repositories });
          return repositories;
        } catch (error) {
          console.error("Get Repo error:", error);
          return null;
        }
      },
      toggleFavorite: async (owner: string, repository: string, isFavorite: boolean) => {
        try {
          if (isFavorite) {
            await axios.delete(`/repo/favorites/${owner}/${repository}`, { withCredentials: true });
          } else {
            await axios.post(
              `/repo/favorites`,
              { owner, repository },
              { withCredentials: true }
            );
          }
          set((state) => {
            if (!state.repo) return state;
            const next = state.repo
              .map((item) =>
                item.owner === owner && item.name === repository
                  ? { ...item, isFavorite: !isFavorite }
                  : item
              )
              .sort((a, b) => {
                if (!!a.isFavorite === !!b.isFavorite) return 0;
                return a.isFavorite ? -1 : 1;
              });
            return { repo: next };
          });
          return true;
        } catch (error) {
          console.error("Toggle favorite error:", error);
          return false;
        }
      },
      clearStore: () => {
        set({ repo: null });
      },
    }),
    {
      name: "repo-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

export default useRepoStore;
